import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from 'ui/pageHeader';
import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { Skeleton } from 'ui/skeleton';
import { InputText } from 'ui/inputs/inputText';
import { COLUMNS } from '../constants';
import { selectEnabledAccounts, getEnabledAccountsIsLoading } from '../selectors';
import { fetchEnabledAccountsRequest } from '../actions';
import { filterEnabledAccountsFn } from '../utils';

export const EnabledAccounts = () => {
  const dispatch = useDispatch();
  const enabledAccounts = useSelector(selectEnabledAccounts);
  const isLoading = useSelector(getEnabledAccountsIsLoading);

  const {
    currentPage,
    filter,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setFilter,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: enabledAccounts,
    sortedBy: 'id',
    filterFn: filterEnabledAccountsFn,
  });

  useEffect(() => {
    dispatch(fetchEnabledAccountsRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        pageActions={
          <InputText
            data-test="filter-enabled-accounts"
            value={filter}
            onChange={setFilter}
            placeholder="Filter by..."
          />
        }
      >
        Enabled accounts
      </PageHeader>
      {isLoading ? (
        <Skeleton height={500} />
      ) : (
        <>
          <Table>
            <TableHeader
              columns={COLUMNS}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
              sortedBy={sortedBy}
              setSortedBy={setSortedBy}
            />
            <TableRows columns={COLUMNS} rows={rows} />
          </Table>
          <PaginationFooter
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            numItems={numItems}
            onUpdate={({ page, pageSize }) => {
              setCurrentPage(page);
              setItemsPerPage(pageSize);
            }}
          />
        </>
      )}
    </>
  );
};
